import React from "react";
import { OrnRule } from "./Ornaments";
import { cx } from "@/lib/classnames";

export const PageHead: React.FC<{
  kicker: string;
  title: string;
  tagline?: string;
  dark?: boolean;
  isRTL: boolean;
}> = ({ kicker, title, tagline, dark = true, isRTL }) => (
  <section
    className="relative"
    style={{ background: dark ? "var(--ink)" : "var(--parchment)" }}
  >
    {dark ? <div className="grain" /> : <div className="grain-soft" />}
    <div className="max-w-page mx-auto px-6 md:px-10 py-20 md:py-28 relative">
      <div
        className={cx(isRTL ? "ff-ar-sans" : "ff-en-sc tracked-widest", "text-[11px] mb-4")}
        style={{ color: "var(--vermillion-2)" }}
      >
        {kicker}
      </div>
      <h1
        className={cx(isRTL ? "ff-ar-serif" : "ff-en-serif", "leading-[1.05]")}
        style={{
          fontSize: "clamp(2.2rem, 4.5vw, 4rem)",
          color: dark ? "var(--parchment)" : "var(--ink)",
          fontWeight: 600,
        }}
      >
        {title}
      </h1>
      {tagline && (
        <p
          className={cx(
            isRTL ? "ff-ar-sans" : "ff-en-body italic",
            "mt-5 max-w-3xl text-lg",
          )}
          style={{ color: dark ? "var(--muted-dark)" : "var(--muted-light)" }}
        >
          {tagline}
        </p>
      )}
      <div className="mt-10 max-w-xs">
        <OrnRule color={dark ? "var(--gold)" : "var(--vermillion)"} />
      </div>
    </div>
  </section>
);
